module.exports = __webpack_public_path__ + "static/media/Libya.39d2c089.png";